import React, { forwardRef, useRef, useEffect } from 'react';

import { Checkbox } from 'coreOld/elements';

import { Wrapper } from './tableCheckboxInputStyle';

interface Props {
  indeterminate?: boolean;
  name?: string;
  onChange?;
  disabled?: boolean;
}

// eslint-disable-next-line react/display-name
const TableCheckboxInput = forwardRef<HTMLInputElement, Props>(
  ({ indeterminate, onChange, ...rest }, ref: React.Ref<HTMLInputElement>) => {
    const defaultRef = useRef(null);
    const resolvedRef: any = ref || defaultRef;

    useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <Wrapper>
        <Checkbox ref={resolvedRef} onChange={onChange} {...rest} />
      </Wrapper>
    );
  }
);

export default TableCheckboxInput;
